var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0003 9.62666C11.7602 9.62666 12.3763 9.0106 12.3763 8.25065C12.3763 7.4907 11.7602 6.87463 11.0003 6.87463C10.2403 6.87463 9.62427 7.4907 9.62427 8.25065C9.62427 9.0106 10.2403 9.62666 11.0003 9.62666Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9995 1.37512C7.20881 1.37512 4.12451 4.32493 4.12451 7.94934C4.12451 9.6754 4.91127 11.9708 6.46287 14.7719C7.70897 17.0209 9.15057 19.0546 9.90037 20.0665C10.0271 20.2394 10.1927 20.38 10.3839 20.477C10.5751 20.5739 10.7864 20.6244 11.0008 20.6244C11.2152 20.6244 11.4265 20.5739 11.6177 20.477C11.8089 20.38 11.9745 20.2394 12.1012 20.0665C12.8497 19.0546 14.2926 17.0209 15.5387 14.7719C17.0878 11.9716 17.8745 9.67625 17.8745 7.94934C17.8745 4.32493 14.7902 1.37512 10.9995 1.37512ZM10.9995 11.0001C10.4556 11.0001 9.92393 10.8388 9.47169 10.5367C9.01946 10.2345 8.66698 9.805 8.45884 9.3025C8.2507 8.8 8.19624 8.24707 8.30235 7.71362C8.40846 7.18018 8.67037 6.69017 9.05497 6.30558C9.43956 5.92098 9.92957 5.65907 10.463 5.55296C10.9965 5.44685 11.5494 5.50131 12.0519 5.70945C12.5544 5.91759 12.9839 6.27007 13.2861 6.7223C13.5882 7.17454 13.7495 7.70622 13.7495 8.25012C13.7487 8.97922 13.4587 9.67823 12.9432 10.1938C12.4276 10.7093 11.7286 10.9993 10.9995 11.0001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocation);
export default __webpack_public_path__ + "static/media/ic-location.040d0f4f75a7f4a861431bbb9bfdeb79.svg";
export { ForwardRef as ReactComponent };